import type { SVGProps } from 'react';

const SvgKeyTag = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 2h5v2H4v3H2zM22 2h-5v2h3v3h2zM2 22v-5h2v3h3v2zM22 22v-5h-2v3h-3v2z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M17.125 10.833h-4.75C11.91 9.474 10.648 8.5 9.163 8.5 7.28 8.5 5.75 10.07 5.75 12s1.53 3.5 3.412 3.5c1.485 0 2.748-.974 3.214-2.333h.199l1.138 1.166 1.137-1.166 1.138 1.166 2.274-2.356zM9.163 13.75c-.939 0-1.707-.787-1.707-1.75s.768-1.75 1.706-1.75c.939 0 1.707.787 1.707 1.75s-.768 1.75-1.707 1.75"
    />
  </svg>
);
export default SvgKeyTag;
